import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-10 px-5 bg-sand-light" data-id="element-202">
      <div className="max-w-2xl mx-auto" data-id="element-203">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.2
          }
        }
      }} data-id="element-204">
          <motion.p variants={fadeUp} className="text-xl md:text-2xl font-medium text-charcoal mb-6" data-id="element-205">
            But here's what most people never realize:
          </motion.p>

          <motion.p variants={fadeUp} className="text-lg text-charcoal-light mb-8" data-id="element-206">
            That question? It's been misleading you this entire time.
          </motion.p>

          <motion.div variants={fadeUp} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm mb-10 border border-sand" data-id="element-207">
            <p className="text-xl md:text-2xl font-serif text-charcoal text-center" data-id="element-208">
              Because you're not the problem.
              <br data-id="element-209" />
              <span className="text-terracotta mt-2 block" data-id="element-210">
                Your nervous system is.
              </span>
            </p>
          </motion.div>

          <motion.h3 variants={fadeUp} className="font-serif text-2xl md:text-3xl text-charcoal mb-6" data-id="element-211">
            The Invisible Pattern Running Your Life
          </motion.h3>

          <motion.p variants={fadeUp} className="text-lg text-charcoal-light mb-6" data-id="element-212">
            Right now, your body is stuck in a loop:
          </motion.p>

          <motion.div variants={fadeUp} className="flex justify-center mb-10" data-id="element-213">
            <div className="relative w-56 h-56 md:w-64 md:h-64" data-id="element-214">
              {/* Layer 1 (back): Rotating dashed circle */}
              <motion.svg className="absolute inset-0 w-full h-full" style={{
              zIndex: 0
            }} viewBox="0 0 200 200" animate={{
              rotate: 360
            }} transition={{
              duration: 12,
              repeat: Infinity,
              ease: 'linear'
            }} data-id="element-215">
                <circle cx="100" cy="100" r="90" fill="none" stroke="#D99A87" strokeWidth="1.5" strokeDasharray="8 6" opacity="0.5" data-id="element-216" />
              </motion.svg>

              {/* Layer 2: Inner pulsing ring */}
              <motion.div className="absolute inset-4 rounded-full border-2 border-terracotta/20" style={{
              zIndex: 1
            }} animate={{
              scale: [1, 1.04, 1],
              opacity: [0.3, 0.6, 0.3]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-217" />

              {/* Layer 3: Connecting arrows */}
              <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
              zIndex: 2
            }} viewBox="0 0 200 200" data-id="element-218">
                <defs data-id="element-219">
                  <marker id="arrowhead" markerWidth="8" markerHeight="6" refX="7" refY="3" orient="auto" data-id="element-220">
                    <polygon points="0 0, 8 3, 0 6" fill="#C87961" opacity="0.7" data-id="element-221" />
                  </marker>
                </defs>

                {/* On Edge (top) → Overthinking (bottom-right) — clockwise right side */}
                <path d="M 120 28 C 170 50, 185 110, 160 155" fill="none" stroke="#C87961" strokeWidth="2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-222" />

                {/* Overthinking (bottom-right) → Drained (bottom-left) — clockwise bottom */}
                <path d="M 140 175 C 120 198, 80 198, 60 175" fill="none" stroke="#C87961" strokeWidth="2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-223" />

                {/* Drained (bottom-left) → On Edge (top) — clockwise left side */}
                <path d="M 38 150 C 15 100, 30 45, 80 25" fill="none" stroke="#C87961" strokeWidth="2" opacity="0.5" markerEnd="url(#arrowhead)" data-id="element-224" />
              </svg>

              {/* Layer 4 (front): Center text */}
              <div className="absolute inset-0 flex items-center justify-center" style={{
              zIndex: 10
            }} data-id="element-225">
                <p className="text-xs text-charcoal-light/60 font-medium tracking-wider uppercase" data-id="element-226">
                  Stuck in a loop
                </p>
              </div>

              {/* Layer 5 (front): On Edge — top center */}
              <motion.div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1" style={{
              zIndex: 10
            }} animate={{
              y: [0, -3, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-227">
                <div className="bg-terracotta text-white text-sm md:text-base font-bold px-5 py-2 rounded-full shadow-md" data-id="element-228">
                  On Edge
                </div>
              </motion.div>

              {/* Layer 5 (front): Overthinking — bottom right (clockwise after On Edge) */}
              <motion.div className="absolute bottom-2 right-0 translate-x-2" style={{
              zIndex: 10
            }} animate={{
              x: [0, 3, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.7
            }} data-id="element-229">
                <div className="bg-terracotta-light text-white text-sm md:text-base font-bold px-5 py-2 rounded-full shadow-md" data-id="element-230">
                  Overthinking
                </div>
              </motion.div>

              {/* Layer 5 (front): Drained — bottom left (clockwise after Overthinking) */}
              <motion.div className="absolute bottom-2 left-0 -translate-x-2" style={{
              zIndex: 10
            }} animate={{
              x: [0, -3, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 1.4
            }} data-id="element-231">
                <div className="bg-charcoal-light text-white text-sm md:text-base font-bold px-5 py-2 rounded-full shadow-md" data-id="element-232">
                  Drained
                </div>
              </motion.div>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="mb-10" data-id="element-233">
            <p className="text-lg text-charcoal mb-4" data-id="element-234">Which is why:</p>
            <ul className="space-y-4 text-lg text-charcoal-light" data-id="element-235">
              <li className="flex items-start gap-3" data-id="element-236">
                <span className="text-sage mt-1" data-id="element-237">•</span>
                <span data-id="element-238">You feel anxious, even when nothing is wrong</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-239">
                <span className="text-sage mt-1" data-id="element-240">•</span>
                <span data-id="element-241">You feel exhausted, but can't relax</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-242">
                <span className="text-sage mt-1" data-id="element-243">•</span>
                <span data-id="element-244">You overthink everything</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-245">
                <span className="text-sage mt-1" data-id="element-246">•</span>
                <span data-id="element-247">You snap, then feel guilty</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-248">
                <span className="text-sage mt-1" data-id="element-249">•</span>
                <span data-id="element-250">You try to rest, but your mind won't stop</span>
              </li>
            </ul>
          </motion.div>

          <motion.p variants={fadeUp} className="text-xl font-serif text-charcoal mb-10 text-center" data-id="element-251">
            This isn't weakness. It's a dysregulated nervous system locked in
            survival mode.
          </motion.p>

          <motion.h3 variants={fadeUp} className="font-serif text-2xl md:text-3xl text-charcoal mb-6" data-id="element-252">
            Why Nothing Has Fully Worked
          </motion.h3>

          <motion.p variants={fadeUp} className="text-lg text-charcoal-light mb-6" data-id="element-253">
            You tried to fix it:
          </motion.p>

          <motion.div variants={fadeUp} className="flex flex-col sm:flex-row sm:flex-wrap gap-2.5 mb-8" data-id="element-254">
            {['Meditation apps', 'Therapy', 'Morning routines', 'Self-care habits', 'Productivity systems'].map((item, idx) => <motion.span key={item} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1,
            duration: 0.4
          }} className="bg-white px-4 py-2.5 rounded-full text-sm font-medium text-charcoal-light border border-sand w-full sm:w-auto text-center" data-id="element-255">
                {item}
              </motion.span>)}
          </motion.div>

          <motion.p variants={fadeUp} className="text-lg text-charcoal-light mb-4" data-id="element-256">
            And for a moment… it worked.
          </motion.p>

          <motion.p variants={fadeUp} className="text-lg font-medium text-charcoal mb-8" data-id="element-257">
            Until it didn't.
          </motion.p>

          <motion.div variants={fadeUp} className="bg-terracotta-light/10 p-6 md:p-8 rounded-2xl border border-terracotta-light/20" data-id="element-258">
            <p className="text-lg text-charcoal mb-2" data-id="element-259">Because:</p>
            <p className="text-xl font-medium text-terracotta-dark leading-snug" data-id="element-260">
              Those solutions only work when your nervous system is already
              regulated. Yours isn't.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}